<template>
  <div id="contenedor-eliminar-contrato-video">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Video </v-card-title>
      <v-card-text>
        <span class="secondary--text"> ¿Desea eliminar el video? </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="mixEliminarContratoVideo"
          :disabled="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixContratoVideos from './mixContratoVideos';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EliminarInsumoContrato',
  mixins: [mixContratoVideos],
  props: {
    contratoVideoEliminar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style>
</style>
